export function formatWingitDate(value) {
  if (!value) return '-';

  const parsed = new Date(`${value}T00:00:00`);
  if (!Number.isFinite(parsed.getTime())) return String(value);

  return parsed.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatWingitTime(value) {
  if (!value) return '-';
  return String(value).slice(0, 5);
}

export function formatWingitDateTime(dateValue, timeValue) {
  return `${formatWingitDate(dateValue)} • ${formatWingitTime(timeValue)}`;
}